<app-cases-iterator [caseNumber]="caseNumber$ | async">
</app-cases-iterator>
